import ko from 'knockout';
import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import config from '@bingads-webui-component-legacy/config/index';

const webpageCondition = window.globalLegacySchema.get('WebpageCondition');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

class Condition {
  constructor(item = {}) {
    koSchema.properties(this, webpageCondition, ['ArgumentOperand', 'Operand']);

    /* eslint-disable */
    this.Operand(item.Operand || 'Url');
    this.ArgumentOperand(item.ArgumentOperand || '');
    this.Operator = ko.computed(() => {
      if (_.contains(['Category', 'CustomLabel'], this.Operand())) {
        return 'Equals';
      }
      return 'Contains';
    });

    this.showSelect = ko.computed(() => {
      return this.Operand() === 'Category';
    });

    this.showSelect.subscribe(() => {
      this.ArgumentOperand('');
    });

    this.showOperatorAndValue = ko.computed(() => {
      return !this.showSelect() || this.ArgumentOperand();
    });
    /* eslint-enable */
  }
}

const operatorMap = {
  'Equals': i18n.get('DSA_AutoTargets_Specific_Target_Equals'),
  'Contains': i18n.get('DSA_AutoTargets_Specific_Target_Contains'),
};

const operandMap = {
  'Url': i18n.get('DSA_AutoTargets_Specific_Target_Operand_URL'),
  'Category': i18n.get('DSA_AutoTargets_Specific_Target_Operand_CATEGORY'),
  'PageTitle': i18n.get('DSA_AutoTargets_Specific_Target_Operand_PAGE_TITLE'),
  'PageContent': i18n.get('DSA_AutoTargets_Specific_Target_Operand_PAGE_CONTENT'),
  'CustomLabel': i18n.get('DSA_AutoTargets_Specific_Target_Operand_Custom_Label'),
};

export default class ViewModel {
  constructor(options = {}) {
    this.options = _.defaults(options, {conditions: [{Operand: 'Url'}]});
    this.items = ko.observableArray(ko.unwrap(this.options.conditions).map( (cond) => {
      return new Condition(cond);
    }));

    if (_.isEmpty(this.items())) {
      this.items.push(new Condition());
    }

    this.setting = ko.observable(this.options.setting);

    this.isCustomLabelEnabled = ko.computed(() => {
      const setting = this.setting();

      return _.result(config.get('Permissions'), 'IsDynamicSearchAdsPageFeedEnabled') && setting.Source !== 'SystemIndex';
    });

    this.operandOptions = ko.computed(() => {
      let operands = this.options.isShowUrlOnly ? [{
        value: 'Url',
        text: operandMap.Url,
      }] : [{
        value: 'Url',
        text: operandMap.Url,
      }, {
        value: 'Category',
        text: operandMap.Category,
      }, {
        value: 'PageTitle',
        text: operandMap.PageTitle,
      }, {
        value: 'PageContent',
        text: operandMap.PageContent,
      }];

      if (!this.options.isShowUrlOnly && this.isCustomLabelEnabled()) {
        operands.push({
          value: 'CustomLabel',
          text: operandMap.CustomLabel,
        });
      }
      return operands;
    });

    this.isCategoriesEmpty = ko.observable(false);

    this.isConditionDeleteEnabled = ko.computed(() => {
      return _.size(this.items()) > 1;
    });

    this.isConditionAddEnabled = ko.computed(() => {
      return _.size(this.items()) < 3;
    });

    /* eslint-disable */
    this.values = ko.computed(() => {
      return this.items().map( (item) => {
        item.DisplayOperand = ko.computed(() => {
          return item.Operand() ? operandMap[item.Operand()] : '';
        });
        item.DisplayOperator = ko.computed(() => {
          return item.Operator() ? operatorMap[item.Operator()] : '';
        });

        if (_.isEmpty(item.errors()) && _.isEmpty(item.ArgumentOperand.errors())) {
          return {
            Operand: item.Operand(),
            ArgumentOperand: item.ArgumentOperand().trim(),
            DisplayOperand: item.DisplayOperand(),
            DisplayOperator: item.DisplayOperator(),
          };
        }
        return {
          Operand: item.Operand(),
          ArgumentOperand: '',
          DisplayOperand: item.DisplayOperand(),
          DisplayOperator: item.DisplayOperator(),
        };
      });
    });
    /* eslint-enable */

    this.addItem = () => {
      this.items.push(new Condition());
    };

    this.deleteItem = (item) => {
      this.items.remove(item);
    };

    this.updateCategories = (categories) => {
      this.categories(categories);
    };

    this.reset = () => {
      this.items([new Condition()]);
    };
  }
}
